import { getApiUrl } from '@/lib/api-url';
import { currentDevTimeHeader } from '@/lib/dev-clock';
import { DEV_TIME_HEADER } from '@sixam/shared/clock';
import { supabase } from '@sixam/supabase/client';

/**
 * Fetch an app API route as the current user. Sends the Supabase access token
 * as a Bearer header (native) and includes cookies (web) so the route's
 * `requireUser` helper authenticates on every platform.
 */
export async function authedFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const {
    data: { session },
  } = await supabase.auth.getSession();

  const headers = new Headers(init.headers);
  if (session?.access_token) {
    headers.set('Authorization', `Bearer ${session.access_token}`);
  }
  const devTime = currentDevTimeHeader();
  if (devTime) headers.set(DEV_TIME_HEADER, devTime);

  return fetch(getApiUrl(path), {
    ...init,
    headers,
    credentials: 'include',
  });
}
